import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { BrandMark } from "@/components/BrandMark";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleCallback() {
  const hasProcessed = useRef(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const match = window.location.hash.match(/session_id=([^&]+)/);
    const sessionId = match?.[1];
    (async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        toast.success(`Welcome${data.is_new ? "" : " back"}, ${(data.name || "").split(" ")[0]}!`);
        navigate(data.is_new ? "/onboarding" : "/", { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed — please try again");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-5 bg-[#FAF9F6]" data-testid="google-callback-loading">
      <BrandMark size={34} />
      <div className="h-8 w-8 rounded-full border-[3px] border-[#FF6B35] border-t-transparent animate-spin" />
      <p className="text-sm text-[#8a7f76] font-figtree">Signing you in with Google…</p>
    </div>
  );
}
